
import {get as getRole} from './role';
export function parsePathId(id: string, getRole: getRole):[string[], string, string] {
	if (id[0] === '[') {
		let end = id.indexOf(']');
		if (end !== -1) {
			let path = id.substr(end + 1);
			if (path[0] === ':') {
				path = path.substr(1);
			}
			const [module, appId] = getRole(id.substr(1, end - 1)) || ['', ''];
			return [path.split('/').filter(Boolean), module, appId];
		}
	}
	let p = id.split(':');
	if (p.length >= 3 && p[0].search(/[#?@]/) === -1 && p[1].search(/[#?]/) === -1) {
		let [appId, id, ...path] = p;
		return [path.join(':').split('/'), id, appId];
	}
	let path: string[] = [], appId: string = '';
	let k = id.indexOf(':');
	if (k !== -1) {
		path = id.substr(k + 1).split('/').filter(Boolean);
		id = id.substr(0, k);
	}
	k = id.indexOf('@');
	if (k !== -1) {
		appId = id.substr(k + 1);
		id = id.substr(0, k);
	}

	return [path, id, appId];
}